/** Nome da marca quando o global Identidade do site ainda não foi preenchido. */
export const DEFAULT_SITE_BRAND = 'Meu Site'
